module.exports = __webpack_public_path__ + "static/media/31JFA1.3c987ab3.jpg";